export default function createEnvironments(baseUrl: string, userManagementUrl?: string, prodUserManagementUrl?: string) {
  const apiEndpoint = '/api';

  const createUrl = (urlPath: string, urlPrefix: string = baseUrl) => {
    const prefix = urlPrefix.endsWith('/') ? urlPrefix : urlPrefix + '/';

    return (
      prefix +
      urlPath
        .split('/')
        .filter((el) => el.length > 0)
        .join('/')
    );
  };

  return {
    login: {
      apiEndpoint: createUrl('/api/v3/login', userManagementUrl ?? ''),
      logout: createUrl('/api/v3/logout', userManagementUrl ?? ''),
    },
    blowerSelection: {
      select: createUrl(apiEndpoint + '/robuschi/blower-selection/select'),
      save: createUrl(apiEndpoint + '/robuschi/blower-selection/save-selection'),
      minFad: createUrl(apiEndpoint + '/robuschi/blower-selection/calculate-min-flow'),
      chart: createUrl(apiEndpoint + '/robuschi/v1/chart/performance'),
      savedSelectionsByUser: (userId: string, brand: 'ROBUSCHI' | 'PEDRO_GIL') =>
        createUrl(`${apiEndpoint}/robuschi/blower-selection/saved-selections/user/${userId}?brand=${brand}`),
      savedSelectionById: (id: string) => createUrl(`${apiEndpoint}/robuschi/blower-selection/saved-selections/${id}`),
    },
    unitConversion: {
      formula: createUrl(apiEndpoint + '/robuschi/unit'),
      convert: createUrl(apiEndpoint + '/robuschi/unit/convert'),
    },
    admin: {
      series: createUrl(apiEndpoint + '/robuschi/admin/series'),
      seriesPaged: (page: number, size: number) => createUrl(`${apiEndpoint}/robuschi/admin/series?page=${page}&size=${size}`),
      seriesById: (id: string) => createUrl(`${apiEndpoint}/robuschi/admin/series/${id}`),
      frames: createUrl(apiEndpoint + '/robuschi/admin/auxiliary-power'),
      framesPaged: (page: number, size: number) => createUrl(`${apiEndpoint}/robuschi/admin/auxiliary-power?page=${page}&size=${size}`),
      frameById: (id: string) => createUrl(`${apiEndpoint}/robuschi/admin/auxiliary-power/${id}`),
      models: createUrl(apiEndpoint + '/robuschi/admin/models'),
      modelsPaged: (page: number, size: number) => createUrl(`${apiEndpoint}/robuschi/admin/models?page=${page}&size=${size}`),
      modelById: (id: string) => createUrl(`${apiEndpoint}/robuschi/admin/models/${id}`),
      motors: createUrl(apiEndpoint + '/robuschi/admin/motors'),
      motorsPaged: (page: number, size: number) => createUrl(`${apiEndpoint}/robuschi/admin/motors?page=${page}&size=${size}`),
      motorById: (id: string) => createUrl(`${apiEndpoint}/robuschi/admin/motors/${id}`),
      motorEfficiency: createUrl(apiEndpoint + '/robuschi/admin/motor-efficiency'),
      motorEfficiencyPaged: (page: number, size: number) =>
        createUrl(`${apiEndpoint}/robuschi/admin/motor-efficiency?page=${page}&size=${size}`),
      motorEfficiencyById: (id: string) => createUrl(`${apiEndpoint}/robuschi/admin/motor-efficiency/${id}`),
      auditLog: (page: number, size: number, entityType?: 'series' | 'model' | 'auxiliary_power' | 'motor' | 'motor_efficiency') => {
        const query = entityType ? `page=${page}&size=${size}&entityType=${entityType}` : `page=${page}&size=${size}`;
        return createUrl(`${apiEndpoint}/robuschi/admin/audit-log?${query}`);
      },
      auditLogUndo: (id: string) => createUrl(`${apiEndpoint}/robuschi/admin/audit-log/${id}/undo`),
    },
  };
}
